import { Moment } from "moment-timezone";
import { classNames } from "../../helpers";

type TimeSlotProps = {
  dateTime: Moment;
  isSelected?: boolean;
  onSelectTime?: (dateTime: Moment) => void;
  isDisabled?: boolean;
};
export default function TimeSlot(props: TimeSlotProps) {
  const { dateTime, isSelected, onSelectTime = () => {}, isDisabled } = props;
  return (
    <button
      className={classNames(
        "flex items-center justify-center w-full h-fit p-1 rounded-md font-medium text-sm whitespace-nowrap",
        isSelected ? "text-white bg-brandblue-600" : "text-gray-600 bg-white",
        isDisabled && "cursor-not-allowed"
      )}
      // We use inline style here to force the disabled styles when the button is disabled
      style={{
        color: isDisabled ? "#D1D5DB" : "",
        backgroundColor: isDisabled ? "#FFFFFF" : "",
      }}
      disabled={isDisabled}
      onClick={() => onSelectTime(dateTime)}
    >
      <time dateTime={dateTime.format("hh:mm A")}>
        {dateTime.format("hh:mm A")}
      </time>
    </button>
  );
}
